// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/Countdown.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/Countdown.tsx");
  import.meta.hot.lastModified = "1740183864611.4397";
}
// REMIX HMR END

import { useState, useEffect } from "react";
import ContentWrapper from "./ContentWrapper";
import Heading from "./Heading";

/**
 * Renders a setion with a countdown.
 * @param {Date} endDate The end date of the countdown.
 * @param {string} title The title of the section.
 * 
 * @returns A full width section with the countdown component.
 *
 */

export default function Countdown({
  endDate,
  title
}) {
  _s();
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  const countdown = () => {
    const formattedTime = new Date(endDate).getTime();
    const second = 1000,
      minute = second * 60,
      hour = minute * 60,
      day = hour * 24;
    const countdownInterval = setInterval(() => {
      const currentTime = new Date().getTime(),
        difference = formattedTime - currentTime;
      setTimeLeft({
        days: Math.floor(difference / day),
        hours: Math.floor(difference % day / hour),
        minutes: Math.floor(difference % hour / minute),
        seconds: Math.floor(difference % minute / second)
      });
      if (difference < 0) {
        clearInterval(countdownInterval);
      }
    }, 1000);
    return countdownInterval;
  };
  useEffect(() => {
    const countdownInterval = countdown();
    return () => {
      clearInterval(countdownInterval);
    };
  }, []);
  return <ContentWrapper spacing="primary" className="bg-primary-700">
      <div className="text-center text-neutral-100">
        <Heading tag="h2" className="!text-neutral-100">{title}</Heading>
        <div className="uppercase text-xl font-normal">
          <ul className="flex children:p-2 sm:children:p-4 justify-center">
            <li>
              <span className="block text-5xl">{timeLeft.days}</span>days
            </li>
            <li>
              <span className="block text-5xl">{timeLeft.hours}</span>hours
            </li>
            <li>
              <span className="block text-5xl">{timeLeft.minutes}</span>minutes
            </li>
            <li>
              <span className="block text-5xl">{timeLeft.seconds}</span>seconds
            </li>
          </ul>
        </div>
      </div>
    </ContentWrapper>;
}
_s(Countdown, "oZ0hmyHHyK2tdLmzYTGUiP3Yycw=");
_c = Countdown;
var _c;
$RefreshReg$(_c, "Countdown");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;